import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool } from 'prop-types'

import extractFilenameFromUrl from './utils/extractFilenameFromUrl'

function UseCaseInfoItem({
  title,
  value = null,
  highlightValue = false,
  showPendingLink = false,
  canDownload = true,
}) {
  const isNotSpecified = (val) => !val || val.toLowerCase() === 'other'
  const hasValue = !isNotSpecified(value)

  const parsedValue = (checkedValue) => {
    if (isNotSpecified(checkedValue)) {
      return null
    }

    const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
    if (urlRegex.test(checkedValue)) {
      const filename = extractFilenameFromUrl(checkedValue)

      // If user cannot download, show only filename without link
      if (!canDownload) {
        return (
          <span title="Purchase this model to download slicer files">
            {filename}
          </span>
        )
      }

      return (
        <a
          href={checkedValue}
          target="_blank"
          rel="noopener noreferrer"
          title={checkedValue}
        >
          {filename}
        </a>
      )
    }

    // Render plain filenames as pending links when explicitly requested
    if (showPendingLink) {
      return (
        <span
          className="use-case-info__item-value--link-pending"
          title="Processing..."
        >
          {checkedValue}
        </span>
      )
    }

    return checkedValue
  }

  return (
    <div className="use-case-info__item">
      <span className="use-case-info__item-title cgt-legacy-text-caption">{title}</span>
      <div className="use-case-info__item-value">
        <span className={
          classnames(
            'cgt-legacy-text-tiny',
            highlightValue && (
              hasValue
                ? 'use-case-info__item-value--specified'
                : 'use-case-info__item-value--not-specified'
            ),
          )
        }>
          {parsedValue(value) || 'Not specified'}
        </span>
      </div>
    </div>
  )
}

UseCaseInfoItem.propTypes = {
  title: string.isRequired,
  value: string,
  highlightValue: bool,
  showPendingLink: bool,
  canDownload: bool,
}

export default UseCaseInfoItem
